import { supabase } from "@/platform/lib/supabase";
import { readErrorFromResponse } from "@/platform/billing/errors";

export interface UspEssayPromptRow {
  id: string;
  year: number;
  theme: string;
  collection: Array<{ id: string; source: string; excerpt: string }> | null;
  expected_approach: string | null;
}

export interface GradeEssayFuvestPayload {
  prompt_id?: string;
  theme: string;
  command?: string;
  collection?: Array<{ id: string; source: string; excerpt: string }>;
  body?: string;
  image_paths?: string[];
}

export interface GradeEssayFuvestResult {
  transcription?: string;
  scores: {
    tema: number;
    genero_modalidade: number;
    coesao_coerencia: number;
    norma_culta: number;
    total: number;
  };
  feedback: string;
  rewrite_plan: string;
  detected_issues: string[];
  confidence: number;
  submission_id: string | null;
  source: "text" | "image";
}

export async function listUspEssayPrompts(): Promise<UspEssayPromptRow[]> {
  const { data, error } = await supabase
    .from("usp_essay_prompts")
    .select("id, year, theme, collection, expected_approach")
    .order("year", { ascending: false });
  if (error) throw error;
  return (data as UspEssayPromptRow[]) ?? [];
}

export async function uploadUspEssayImages(params: {
  userId: string;
  submissionUuid: string;
  files: File[];
}): Promise<string[]> {
  const paths: string[] = [];
  for (let i = 0; i < params.files.length; i++) {
    const file = params.files[i];
    if (!file) continue;
    const ext = file.name.split(".").pop()?.toLowerCase() || "jpg";
    const path = `${params.userId}/${params.submissionUuid}/page-${i + 1}.${ext}`;
    const { error } = await supabase.storage
      .from("usp-essays")
      .upload(path, file, { contentType: file.type, upsert: true });
    if (error) throw new Error(`upload ${path}: ${error.message}`);
    paths.push(path);
  }
  return paths;
}

export async function gradeEssayFuvest(
  payload: GradeEssayFuvestPayload,
): Promise<GradeEssayFuvestResult> {
  const { data: sessionData } = await supabase.auth.getSession();
  const token = sessionData.session?.access_token;
  if (!token) throw new Error("Sessão expirada. Entre novamente.");

  const res = await fetch("/api/grade-essay-fuvest", {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    throw await readErrorFromResponse(res);
  }
  return (await res.json()) as GradeEssayFuvestResult;
}
